import { Badge, Card, Col, Divider, Row, Spin, Statistic } from 'antd';
import React from 'react';
import Chart from 'react-apexcharts';
import './LiveStatusCard.css';
import { getSpeedThreshold } from '../../../../utils';
import { useAuth } from '@tenderd/track-web-utils';
var LiveStatusCard = function (_a) {
    var equipments = _a.equipments, loading = _a.loading, devicesTotalCount = _a.devicesTotalCount;
    var working = 0, idle = 0, off = 0, none = 0;
    var account = useAuth().account;
    var speedThreshold = getSpeedThreshold(account.id);
    equipments &&
        Object.values(equipments).forEach(function (device) {
            if (device.ignition_status === true) {
                if ((device.engine_rpm > device.idling_rpm && device.engine_rpm > 0) || (device.speed > speedThreshold)) {
                    working++;
                }
                else {
                    idle++;
                }
            }
            else if (device.ignition_status === false) {
                off++;
            }
            ;
        });
    none = devicesTotalCount - (working + idle + off);
    var pieData = [
        { x: 'Working', y: working },
        { x: 'Idle', y: idle },
        { x: 'Ignition off', y: off },
        { x: 'No telematics', y: none },
    ];
    return (React.createElement(Col, { span: 24 },
        React.createElement(Spin, { spinning: loading },
            React.createElement(Card, { title: "Live equipment status", extra: React.createElement(Badge, { status: "processing", text: "Updated live" }), className: "live-equipment" },
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 4 },
                        React.createElement(Chart, { options: {
                                dataLabels: {
                                    enabled: false,
                                },
                                legend: {
                                    show: false,
                                },
                                colors: [
                                    '#27ae60',
                                    '#e67e22',
                                    '#e74c3c',
                                    '#2c3e50',
                                ],
                                labels: pieData.map(function (a) { return a.x; }),
                            }, series: pieData.map(function (a) { return a.y; }), type: "pie", height: 200 })),
                    React.createElement(Col, { span: 1 },
                        React.createElement(Divider, { type: "vertical" })),
                    React.createElement(Col, { xs: 19 },
                        React.createElement(Row, { style: { marginTop: 15 } },
                            React.createElement(Col, { xs: 6 },
                                React.createElement(Statistic, { title: "Working (On and moving)", valueStyle: { color: '#27ae60' }, value: working, suffix: "equipment" })),
                            React.createElement(Col, { xs: 6 },
                                React.createElement(Statistic, { title: "Idle (On and not moving)", valueStyle: { color: '#e67e22' }, value: idle, suffix: "equipment" })),
                            React.createElement(Col, { xs: 6 },
                                React.createElement(Statistic, { title: "Ignition off", value: off, valueStyle: { color: '#e74c3c' }, suffix: "equipment" })),
                            React.createElement(Col, { xs: 6 },
                                React.createElement(Statistic, { title: "No telematics", value: none, valueStyle: { color: '#2c3e50' }, suffix: "equipment" })))))))));
};
export default LiveStatusCard;
